import React from 'react';
import { debounce } from 'lodash';
import SearchIcon from '@mui/icons-material/Search';
import { Typeahead, Highlighter } from 'react-bootstrap-typeahead'; 
import { Col, Form, Spinner } from 'react-bootstrap';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';
export interface Option {
  id: number; label: any; value: any; code: string; name: string;
}

interface Props {
  id?: string;
  hidden?: boolean;
  borderless?: boolean;
  label?: string;
  option: Option[];
  mdCol?: string;
  name: string;
  values?: any;
  onChangeItem?: (e: any) => void;
  isValid?: boolean;
  feedback?: any;
  defautlValues?: any;
  disabled?: boolean;
  placeholder?: string;
  form: any;
  className?: string;
  logo?: string;
  onSearch: (keyword: string) => void;
  iconClass?: string;
  icon?: any;
  inputRef?: any;
  isLoading?: boolean;
  emptyLabel?: any;
  clearOption?: () => void;
  labelCustom?: any;
  labelClass?: string;
}

const AdvSelectSearchInput = (props: Props) => {
  let filterByFields = ['label', 'code'];
  const [selected, setSelected] = React.useState([]);

  //  fix filterBy warning
  if (props.option && props.option.length > 0) {
    if (
      props.option.hasOwnProperty('label') &&
      props.option.hasOwnProperty('value') &&
      props.option.hasOwnProperty('code') &&
      props.option.hasOwnProperty('name')
    ) {
      filterByFields = ['label', 'value', 'code', 'name'];
    }
  }

  return props.hidden ? null : (
    <Form.Group
      className={`py-2 ${props.className ?? ''}`.trim()}
      name={props.name}
      as={Col}
      md={props.mdCol || '6'}
      controlId={`${props.name}_ID`}
    >
      {props.labelCustom!==undefined ? (
        <label htmlFor={props.id || props.name} className = {props.labelClass} >
          {props.label}
          {props.labelCustom && (props.labelCustom)}
        </label>       
      ) : (
        <Form.Label style={{ fontSize: '1rem', color: '#4E5A6F' }} className={props.logo}>
          {props.label}
          {props.labelCustom && (props.labelCustom)}
        </Form.Label>
      )}

      <Typeahead
        id={props.name}
        disabled={props.disabled}
        onInputChange={debounce((e) => props.onSearch(e), 500)}
        onChange={(selected: any) => {
          try {
            setSelected(selected);
            props.onChangeItem && props.onChangeItem(selected[0]);

            if (selected[0]?.value) {
              props.form.setFieldValue(props.name, selected[0].value);
            }
          } catch (ex) {
            // skip
          }
        }}
        emptyLabel={
          props.emptyLabel ? (
            props.emptyLabel
          ) : (
            <>
              {props.option?.length === 0 && !!props.values.length && (
                <Stack alignItems={'center'}>
                  {props.option?.length === 0 && !!props.values.length ? (
                    <>
                      <Typography sx={{ color: '#0c2551' }}>Not found</Typography>
                    </>
                  ) : (
                    <>{props.isLoading && <Spinner color="primary" animation="border" />}</>
                  )}
                </Stack>
              )}
            </>
          )
        }
        labelKey="label"
        // labelKey={(option: any) => {
        //   const item = option as Option;
        //   return item.label; 
        // }}

        // renderMenuItemChildren={(option:any) => {
        //   // Ép kiểu (cast) option thành kiểu Option đã định nghĩa
        //   const item = option as Option;
        //   return (
        //     // Thêm thuộc tính title vào thẻ div bọc ngoài
        //     <div title={item.label || item.code} style={{ width: '100%' }}>
        //       {item.label}
        //       {item.code && <span style={{ marginLeft: '8px', color: '#888' }}>({item.code})</span>}
        //     </div>
        //   );
        // }}
        renderMenuItemChildren={(option: any, { text }) => {
          const item = option as Option;
          return (
            <div title={item.label || item.code} style={{ width: '100%' }}>
              <Highlighter search={text}>
                {item.label}
              </Highlighter>
            </div>
          );
        }}
        defaultSelected={props.values ? [props.values] : undefined}
        options={props.option}
        filterBy={filterByFields}
        ref={props.inputRef}
        isLoading={props.isLoading}
        onBlur={() => {
          if (!selected.length) {
            props.inputRef?.current?.clear();
            if (props.clearOption) props.clearOption();
          }
        }}
      />
      <div className={`${props.iconClass ?? 'text-field-light'} icon-search-prefix `}>
        {props.icon ? props.icon : <SearchIcon />}
      </div>
      {props.feedback && (
        <div className="sized70 text-field-light w-100 d-flex justify-content-between mh-1rem">
          {props.feedback}
        </div>
      )}
  <style scoped>{`
  .rbt > div > input {
    padding-left: 32px;
  }
  .rbt-aux {
    position: absolute;
    top:16px;
    left:9px;
  }
  .rbt-menu li.active a,
  .rbt-menu li:hover a {
    background-color: #007bff !important;
    color: white !important;
    background-image: none !important;
  }  
`}</style>
    </Form.Group>
  );
};

export default AdvSelectSearchInput;
